import React from 'react';

import FinishContentLayout from './FinishContentLayout';

function MemberFinishContentPC(props) {
  return <FinishContentLayout {...props} />;
}

export default MemberFinishContentPC;
